export const config = {
    idCondominio: 3,
    usuario: '85538791000160',
    senha: '85538791000160',
    urlApi: 'https://dev.api.cap-app.com.br'
}